<template>
  <table
    v-if="emails.length"
    class="table mt-0 mb-0 full-width">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">{{ $t('purchase.notifications.createdAt') }}</th>
        <th scope="col" class="border-0">{{ $t('purchase.notifications.userName') }}</th>
        <th scope="col" class="border-0">{{ $t('purchase.notifications.type') }}</th>
        <th scope="col" class="border-0">{{ $t('purchase.notifications.receiver') }}</th>
        <th scope="col" class="border-0">{{ $t('purchase.notifications.sendingType') }}</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(item, index) of emails"
        :key="'status-' + index">
        <td class="align-middle">
          {{ item.created_at }}
        </td>
        <td class="align-middle">
          {{ item.user_name }}
        </td>
        <td class="align-middle">
          {{ $t('purchase.notifications.types.' + item.type) }}
        </td>
        <td class="align-middle">
          {{ item.receiver }}
        </td>
        <td class="align-middle">
          {{ $t('purchase.notifications.sendingTypes.' + item.sending_type) }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'purchase-notifications',
  props: [
    'emails'
  ]
}
</script>
